<div class="main-div content-w-98">
  <div class="title-div">
    <div class="headerName">
      <span>Project reporting</span>
    </div>
    <div class="subTitleName">
      <span>Generate your report </span>
    </div>
  </div>

  <ng-container *ngIf="showIncorrectEOLNotification">
    <piqet-angular-incorrect-data-notification
      [message]="incorrectValueMessage"
      [buttonName]="incorrectBtnName"
      [componentName]="'end-of-life'"
      (eolAction)="eolAction($event)"
    ></piqet-angular-incorrect-data-notification>
  </ng-container>

  <ng-container *ngIf="showIncorrectFillingNotification">
    <piqet-angular-incorrect-data-notification
      [message]="incorrectFillingValueMessage"
      [componentName]="'fill-data-list'"
      [buttonName]="incorrectFillingBtnName"
      (eolAction)="eolAction($event)"
    ></piqet-angular-incorrect-data-notification>
  </ng-container>

  <div class="dropdowns-div">
    <form [formGroup]="reportChartForm">
      <!-- Report title  -->
      <!-- Hide for Excel summery report -->

      <div class="row" *ngIf="isShowReportTitle && !isExportProjectSummary">
        <div class="col-12">
          <p *ngIf="isShowReportTitle" class="note-div gray-font">Edit report name</p>
        </div>
        <div class="col-12 input-div">
          <div class="form-group required" aria-required="true">
            <piqet-angular-common-input
              formControlName="reportTitle"
              [control]="reportChartForm.get('reportTitle')"
              label="Report title"
              placeholder="Report title"
              inputType="text"
              [preventDot]="true"
              [submitted]="finalSubmit"
            >
            </piqet-angular-common-input>
          </div>
        </div>
      </div>

      <!-- Report Format List -->
      <div class="d-flex justify-content-end" *ngIf="showEdit">
        <a class="add-link" target="_blank" routerLink="/my-organization/project-report-setting"
          ><span class="redirectLinkText">Add project report custom setting</span></a
        >
        <a
          class="setLinkIconPosition"
          target="_blank"
          replaceUrl="true"
          routerLink="/my-organization/project-report-setting"
        >
          <img src="./assets/icons/redirect-icon.svg" alt="" width="15" height="13" />
        </a>
        <span class="setLinkIconPosition" (click)="getCustomReport()"
          ><img src="./assets/icons/refresh-circle.svg" alt="" width="14" height="13"
        /></span>
      </div>

      <div class="row scenarios-div ng-select-div reportGenerationDrd">
        <div class="col-12 col-md-6">
          <label
            *ngIf="reportChartForm.controls['newFormateList']?.value"
            class="sub-header-drpdown pb-2"
            >Report format</label
          >
          <ng-select
            [clearable]="false"
            [clearOnBackspace]="false"
            #reportFormate
            joyrideStep="adv-14"
            stepPosition="top"
            text="Select from a PDF, PPT or excel report format."
            (prev)="onPrev('adv-14')"
            (change)="onChangeNewReportList($event)"
            formControlName="newFormateList"
            [items]="newFormateList"
            [searchable]="false"
            bindLabel="name"
            [searchFn]="commonInputSearchName"
            [multiple]="false"
            placeholder="Report format"
          >
            <ng-template ng-header-tmp>
              <div class="has-feedback">
                <input
                  placeholder="Search..."
                  (input)="reportFormate.filter($any($event.target).value)"
                  type="text"
                  class="form-control search-input"
                  id="inputValidation"
                />
                <span class="form-control-feedback">
                  <i class="fa fa-search icon"></i>
                </span>
              </div>
            </ng-template>
            <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
              <div
                [ngOptionHighlight]="search"
                title="{{ item?.name }}"
                [class.disabled]="item?.disabled"
              >
                {{ item.name }} &nbsp;
                <span
                  [style.color]="comingSoonText.color"
                  [style.fontStyle]="'italic'"
                  [style.fontWeight]="'bold'"
                  [style.fontSize]="comingSoonText.fontSize"
                  *ngIf="item?.disabled && item.name.toLowerCase() == lcaPresentenceText"
                  >{{ comingSoonText.status }}</span
                >
              </div>
            </ng-template>
          </ng-select>
          <div
            *ngIf="
              (finalSubmit || reportChartForm.controls['newFormateList']?.touched) &&
              reportChartForm.controls['newFormateList']?.invalid
            "
            class="input-error"
          >
            Report format is required.
          </div>
        </div>

        <div class="col-12 col-md-6 reportGenerationDrd">
          <label
            *ngIf="
              reportChartForm.controls['reportFormatByList']?.value ||
              reportChartForm.controls['newFormateList']?.value
            "
            class="sub-header-drpdown pb-2"
            >Report type</label
          >
          <ng-select
            [clearable]="false"
            [clearOnBackspace]="false"
            #reportListByFormat
            joyrideStep="adv-15"
            stepPosition="top"
            text="Select a predefined report or create your own custom report."
            (change)="onChnageReportListByFormate($event)"
            formControlName="reportFormatByList"
            [items]="reportListByFormate"
            [searchable]="false"
            bindLabel="name"
            [searchFn]="commonInputSearchName"
            [multiple]="false"
            placeholder="Report type *"
            groupBy="childItems"
            [readonly]="
              isReportListByFormateDisabled ||
              isCheckeportListByFormateById == NewReportFormatEnum.ExportRawData ||
              isCheckeportListByFormateById == NewReportFormatEnum.ExportRawDataNew ||
              isExportProjectSummary
            "
          >
            <ng-template ng-header-tmp>
              <div class="has-feedback">
                <input
                  placeholder="Search..."
                  (input)="reportListByFormat.filter($any($event.target).value)"
                  type="text"
                  class="form-control search-input"
                  id="inputValidation"
                />
                <span class="form-control-feedback">
                  <i class="fa fa-search icon"></i>
                </span>
              </div>
            </ng-template>

            <!-- Updated optgroup template to show crown icon for disabled groups -->
            <ng-template ng-optgroup-tmp let-item="item" let-search="searchTerm">
              <div
                title="{{ item?.name }}"
                [class.disabled]="item?.disabled"
                class="option-group-content"
              >
                <span class="option-text-wrapper">
                  <span [ngOptionHighlight]="search">{{ item?.name }}</span>
                  <app-crown-icon
                    *ngIf="item?.disabled && item?.isFeatureDisabled"
                    [tooltip]="'This feature is not available in your current plan'"
                    [size]="16"
                    [color]="'#9747FF'"
                    [customClass]="'ml-2'"
                  >
                  </app-crown-icon>
                </span>
              </div>
            </ng-template>

            <!-- Option template with crown icon for child items (excluding dummy records) -->
            <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
              <div
                title="{{ item?.name }}"
                [class.disabled]="item?.disabled"
                class="option-content"
              >
                <span class="option-text-wrapper">
                  <span [ngOptionHighlight]="search">{{ item.name }}</span>
                  <app-crown-icon
                    *ngIf="item?.disabled && item?.isFeatureDisabled && item?.id !== 0"
                    [tooltip]="'This feature is not available in your current plan'"
                    [size]="16"
                    [color]="'#9747FF'"
                    [customClass]="'ml-2'"
                  >
                  </app-crown-icon>
                </span>
              </div>
            </ng-template>
          </ng-select>
          <div
            *ngIf="
              isCheckeportListByFormateById == NewReportFormatEnum.ExportRawData ||
              isCheckeportListByFormateById == NewReportFormatEnum.ExportRawDataNew
            "
            class="input-error"
          >
            *Unavailable for report format
          </div>
          <div
            *ngIf="
              (finalSubmit || reportChartForm.controls['reportFormatByList']?.touched) &&
              reportChartForm.controls['reportFormatByList']?.invalid
            "
            class="input-error"
          >
            Report type is required.
          </div>
        </div>
      </div>

      <!-- Functional Unit &  Baseline scenario -->
      <!-- Show for all -->
      <div class="row" *ngIf="!isExportProjectSummary">
        <!-- Functional Unit -->
        <div class="col-12 col-md-6 ng-select-div reportGenerationDrd">
          <label
            *ngIf="
              reportChartForm.controls['functionalUnit']?.value ||
              reportChartForm.controls['baselineScenario']?.value
            "
            class="sub-header-drpdown pb-2"
            >Functional unit</label
          >
          <ng-select
            formControlName="functionalUnit"
            [clearable]="false"
            [clearOnBackspace]="false"
            [items]="functionalUnitList"
            #functionalUnit
            [searchable]="false"
            bindLabel="name"
            [searchFn]="commonInputSearchName"
            placeholder="Functional unit"
          >
            <ng-template ng-header-tmp>
              <div class="has-feedback">
                <input
                  placeholder="Search..."
                  type="text"
                  class="form-control search-input"
                  id="inputValidation"
                  (input)="functionalUnit.filter($any($event.target).value)"
                />
                <span class="form-control-feedback">
                  <i class="fa fa-search icon"></i>
                </span>
              </div>
            </ng-template>
            <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
              <div [ngOptionHighlight]="search" title="{{ item?.name }}">{{ item.name }}</div>
            </ng-template>
          </ng-select>
          <div
            *ngIf="
              (finalSubmit || reportChartForm.controls['functionalUnit']?.touched) &&
              reportChartForm.controls['functionalUnit']?.invalid
            "
            class="input-error"
          >
            Function unit is required
          </div>
        </div>

        <!-- Baseline scenario -->
        <div class="col-12 col-md-6 ng-select-div reportGenerationDrd">
          <label
            *ngIf="
              reportChartForm.controls['baselineScenario']?.value ||
              reportChartForm.controls['functionalUnit']?.value
            "
            class="sub-header-drpdown pb-2"
            >Base scenario</label
          >
          <ng-select
            #baselineScenario
            [clearable]="false"
            [clearOnBackspace]="false"
            formControlName="baselineScenario"
            [items]="baselineScenarioList"
            [searchable]="false"
            bindLabel="description"
            [searchFn]="commonInputSearchName"
            (change)="changeBaseScenario($event)"
            placeholder="Base scenario"
          >
            <ng-template ng-header-tmp>
              <div class="has-feedback">
                <input
                  placeholder="Search..."
                  type="text"
                  class="form-control search-input"
                  id="inputValidation"
                  (input)="baselineScenario.filter($any($event.target).value)"
                />
                <span class="form-control-feedback">
                  <i class="fa fa-search icon"></i>
                </span>
              </div>
            </ng-template>
            <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
              <div [ngOptionHighlight]="search" title="{{ item?.description }}">
                {{ item.description }}
              </div>
            </ng-template>
          </ng-select>
          <div
            *ngIf="
              (finalSubmit || reportChartForm.controls['baselineScenario']?.touched) &&
              reportChartForm.controls['baselineScenario']?.invalid
            "
            class="input-error"
          >
            Please select base scenario
          </div>
        </div>
      </div>

      <div class="row" *ngIf="!isExportProjectSummary">
        <div class="form-group">
          <div class="side-by-side-container">
            <div class="row">
              <div class="form-group">
                <label class="sub-header-drpdown pb-2">Functional unit text</label>
                <div class="services-form">
                  <textarea
                    formControlName="functionalUnitText"
                    class="resizable-textarea"
                    cols="20"
                    id="Description"
                    name="Description"
                    rows="6"
                    (input)="onFunctionalUnitChange()"
                    placeholder="Functional unit text"
                    (change)="onSaveFunctionalUnitText()"
                  ></textarea>
                  <div *ngIf="finalSubmit" class="input-error">
                    <ng-container *ngTemplateOutlet="functionalUnitTextError"></ng-container>
                  </div>
                </div>
              </div>
            </div>

            <piqet-angular-text-preview
              [text]="functionalUnitText"
              [labelText]="'Functional unit text preview in reports'"
              [textPrefix]="'Accordingly, the FU for this study is '"
              [textSuffix]="''"
              [highlightText]="true"
              [maxLength]="50"
              [truncatePosition]="'end'"
              [truncateIndicator]="'...'"
            ></piqet-angular-text-preview>
          </div>
        </div>
      </div>

      <!-- Scenarios to Include -->
      <!-- Show for all -->
      <div class="scenarios-to-include-div">
        <div class="row">
          <div class="col-12">
            <p *ngIf="chooseUpToMessage != ''" class="note-div gray-font">
              {{ chooseUpToMessage }}
            </p>
          </div>
          <div class="col-12 ng-select-div reportGenerationDrd">
            <label
              *ngIf="reportChartForm.controls['includeScenario']?.value"
              class="sub-header-drpdown pb-2"
              >Scenarios to include</label
            >
            <ng-select
              #scenario
              formControlName="includeScenario"
              [clearable]="false"
              [items]="includeScenarioList"
              [searchable]="false"
              bindLabel="description"
              bindValue="idStr"
              [searchFn]="commonInputSearchDes"
              (click)="enableAllScenarioDrp()"
              [maxSelectedItems]="maxAllowedSelectedItems"
              [multiple]="true"
              placeholder="Scenarios to Include"
              [readonly]="isEnableAllScenarioDrp"
              (change)="multiSelectIncludeScenarios($event)"
            >
              <ng-template ng-header-tmp>
                <div class="has-feedback">
                  <input
                    placeholder="Search..."
                    type="text"
                    class="form-control search-input"
                    id="inputValidation"
                    (input)="scenario.filter($any($event.target).value)"
                  />
                  <span class="form-control-feedback">
                    <i class="fa fa-search icon"></i>
                  </span>
                </div>
              </ng-template>
              <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                <div [ngOptionHighlight]="search" title="{{ item?.description }}">
                  {{ item?.description }}
                </div>
                <span *ngIf="item?.idStr == selectedBaseScenario" class="badge scenario-badge"
                  >Base scenario</span
                >
              </ng-template>
            </ng-select>
            <div
              *ngIf="finalSubmit && reportChartForm.controls['includeScenario']?.invalid"
              class="input-error"
            >
              Please select scenarios
            </div>
            <div class="input-error" *ngIf="isShowScenarioNotification">
              <span>Select a base scenario to proceed.</span>
            </div>
          </div>
        </div>
      </div>

      <!-- Check Box  -->
      <div>
        <div class="row">
          <!-- Exclude product impacts Check box -->
          <!-- Show for all -->
          <!-- <div class="col-12 check-box-div">
            <div class="d-flex">
              <div>
                <input formControlName="excludeProductImpacts" type="checkbox" class="chkOverview"
                  (change)="isExcludeProduct()">
              </div>
              <div>
                <span style="color: black; margin-left: 10px;">Exclude product impacts</span>
              </div>
            </div>
          </div> -->

          <!-- Include Input Information Check box -->
          <!-- show only for Simple Slide Deck & Slides Report -->
          <div class="col-12 check-box-div" *ngIf="isShowIncludeInputInformation">
            <div class="d-flex checkBoxAlienMent">
              <div>
                <input
                  formControlName="includeInputInformation"
                  type="checkbox"
                  class="chkOverview"
                />
              </div>
              <div>
                <span style="color: black; margin-left: 10px">Include input information</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Impact categories -->
      <!-- Show for all -->
      <div class="row" *ngIf="!isCheckeportListByTypeByFlag && !isExportProjectSummary">
        <div class="col-12 ng-select-div reportGenerationDrd">
          <label
            *ngIf="reportChartForm.controls['impactCategories']?.value"
            class="sub-header-drpdown pb-2"
            >Impact categories</label
          >
          <ng-select
            #impactCategories
            [clearable]="false"
            [clearOnBackspace]="false"
            (change)="hideShowCategoriesToInclude($event)"
            formControlName="impactCategories"
            [items]="impactCategoriesList"
            [searchable]="false"
            bindLabel="name"
            [searchFn]="commonInputSearchName"
            placeholder="Impact categories"
            [readonly]="isDisabledSelectImpactCategories"
          >
            <ng-template ng-header-tmp>
              <div class="has-feedback">
                <input
                  placeholder="Search..."
                  type="text"
                  class="form-control search-input"
                  id="inputValidation"
                  (input)="impactCategories.filter($any($event.target).value)"
                />
                <span class="form-control-feedback">
                  <i class="fa fa-search icon"></i>
                </span>
              </div>
            </ng-template>
            <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
              <div
                title="{{ item?.name }}"
                [class.disabled]="item?.disabled"
                class="option-content"
              >
                <span class="option-text-wrapper">
                  <span [ngOptionHighlight]="search"> {{ item.name }}</span>
                  <app-crown-icon
                    *ngIf="item?.disabled && item?.isFeatureDisabled"
                    [tooltip]="'This feature is not available in your current plan'"
                    [size]="16"
                    [color]="'#9747FF'"
                    [customClass]="'ml-2'"
                  >
                  </app-crown-icon>
                </span>
              </div>
            </ng-template>
          </ng-select>
          <div
            *ngIf="finalSubmit && reportChartForm.controls['impactCategories']?.invalid"
            class="input-error"
          >
            Impact categories are required.
          </div>
        </div>
      </div>

      <!-- Categories to include -->
      <!-- Hide for carbon footprint -->
      <div
        class="scenarios-to-include-div"
        *ngIf="
          !isCheckeportListByTypeByFlag && isShowCategoriesToInclude && !isExportProjectSummary
        "
      >
        <div class="row">
          <div class="col-12" *ngIf="chooseUpToMessageFOrOther">
            <p class="note-div gray-font">{{ chooseUpToMessageFOrOther }}</p>
          </div>
          <div class="col-12 ng-select-div reportGenerationDrd">
            <label
              *ngIf="reportChartForm.controls['includeCategories']?.value"
              class="sub-header-drpdown pb-2"
              >Categories to include</label
            >
            <ng-select
              formControlName="includeCategories"
              [clearable]="false"
              [items]="includeCategoriesList"
              [searchable]="false"
              bindLabel="name"
              bindValue="id"
              [ngClass]="
                reportChartForm.controls['includeCategories'].value?.length > 11
                  ? 'multi-select'
                  : ''
              "
              [searchFn]="commonInputSearchName"
              [multiple]="true"
              [maxSelectedItems]="maxAllowedSelectedItemsForSlide"
              placeholder="Categories to include"
              (change)="multiSelectIncludeCategories($event)"
              #select
            >
              <ng-template ng-header-tmp>
                <div class="has-feedback">
                  <input
                    placeholder="Search..."
                    type="text"
                    (input)="select.filter($any($event.target).value)"
                    class="form-control search-input"
                    id="inputValidation"
                  />
                  <span class="form-control-feedback">
                    <i class="fa fa-search icon"></i>
                  </span>
                </div>
              </ng-template>
              <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                <div [ngOptionHighlight]="search" title="{{ item?.name }}">{{ item.name }}</div>
              </ng-template>
            </ng-select>
            <div
              *ngIf="
                (finalSubmit || reportChartForm.controls['includeCategories']?.touched) &&
                reportChartForm.controls['includeCategories']?.invalid
              "
              class="input-error"
            >
              Categories to include are required.
            </div>
          </div>
        </div>
      </div>

      <ng-container *ngIf="joyrideService.isTourInProgress() || isCheckeportListByFormateById == 1">
        <app-feature-lock
          [isDisabled]="isSensitivityFeatureDisabled"
          [featureCode]="FeatureCodes.REPORTS_SENSITIVITY_ANALYSIS"
          [popupPosition]="'top'"
        >
          <p
            *ngIf="
              !joyrideService.isTourInProgress() &&
              !isSensitivityFeatureDisabled &&
              includeScenarioList?.length < 2
            "
            class="text-danger my-3"
          >
            To enable Sensitivity analysis, add more than 1 scenario in your project
          </p>
          <div
            formGroupName="ISOReportForm"
            [ngClass]="includeScenarioList?.length < 2 ? 'disabled-project' : ''"
            [piqetAngularSectionAccess]="FeatureCodes.REPORTS_SENSITIVITY_ANALYSIS"
          >
            <div [formGroup]="sensitivityReportForm">
              <div *ngFor="let item of formArray; let i = index" formArrayName="items">
                <div
                  formGroupName="{{ i }}"
                  class="sensitivity-analysis-item"
                  [class.remove-hover-border]="hoveredIndex === i"
                >
                  <span
                    class="sensiHeading header-text-crown-icon"
                    joyrideStep="adv-16"
                    stepPosition="right"
                    (prev)="onPrev('adv-16')"
                    (next)="onNext('adv-16')"
                    text="You may conduct multiple sensitivity analyses to present how variations in input data could affect the study results."
                    >Sensitivity analysis {{ i + 1 }}
                    <button
                      *ngIf="i != 0"
                      type="button"
                      class="btn-hover-remove"
                      (click)="removeSensitivityItem(i)"
                      (mouseenter)="setHoveredIndex(i)"
                      (mouseleave)="setHoveredIndex(null)"
                      ngbTooltip="Click to remove this sensitivity analysis from the list"
                      placement="left"
                      tooltipClass="sku-tooltip"
                    >
                      Remove
                    </button>
                    <app-crown-icon *ngIf="isSensitivityFeatureDisabled"></app-crown-icon>
                  </span>
                  <p class="text-danger my-2" *ngIf="isCheckVariation && errorIndex == i">
                    Variation is required
                  </p>
                  <div class="row scenarios-div ng-select-div reportGenerationDrd">
                    <div class="col-12">
                      <label
                        class="sub-header-drpdown pb-2"
                        *ngIf="sensitivityReportForm.get('items').at(i).get('addRefrences').value"
                        >Add reference for sensitivity analysis</label
                      >
                      <ng-select
                        [clearable]="true"
                        [clearOnBackspace]="false"
                        #addRedefrences
                        joyrideStep="adv-17"
                        stepPosition="right"
                        (next)="onNext('adv-17')"
                        (prev)="onPrev('adv-17')"
                        [items]="baselineScenarioList"
                        [searchable]="false"
                        bindLabel="description"
                        text="Label a reference scenario to be used as a baseline for the analysis."
                        [formControlName]="'addRefrences'"
                        bindValue="idStr"
                        [searchFn]="commonInputSearchDes"
                        [multiple]="false"
                        placeholder="Add reference for sensitivity analysis"
                        (change)="selectAddRefrences($event, i)"
                        (clear)="resetCalculations(i)"
                      >
                        <ng-template ng-header-tmp>
                          <div class="has-feedback">
                            <input
                              placeholder="Search..."
                              (input)="addRedefrences.filter($any($event.target).value)"
                              type="text"
                              class="form-control search-input"
                              id="inputValidation"
                            />
                            <span class="form-control-feedback">
                              <i class="fa fa-search icon"></i>
                            </span>
                          </div>
                        </ng-template>
                        <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                          <div [ngOptionHighlight]="search" title="{{ item?.description }}">
                            {{ item.description }}
                          </div>
                        </ng-template>
                      </ng-select>
                    </div>
                  </div>
                  <div class="row scenarios-div ng-select-div reportGenerationDrd">
                    <div class="col-12 col-md-6">
                      <label
                        class="sub-header-drpdown pb-2"
                        *ngIf="sensitivityReportForm.get('items').at(i).get('variationOne').value"
                        >Variation 1</label
                      >
                      <label
                        *ngIf="
                          !sensitivityReportForm.get('items').at(i).get('variationOne').value &&
                          sensitivityReportForm.get('items').at(i).get('variationTwo').value
                        "
                        style="visibility: hidden"
                        class="sub-header-drpdown pb-2"
                        >Holder_Text</label
                      >
                      <ng-select
                        [clearable]="true"
                        [clearOnBackspace]="false"
                        #Variation1
                        joyrideStep="adv-18"
                        stepPosition="right"
                        text="Label up to four variations, which are scenarios used throughout the project."
                        (prev)="onPrev('adv-18')"
                        [formControlName]="'variationOne'"
                        [items]="variationLists"
                        [searchable]="false"
                        bindLabel="description"
                        [searchFn]="commonInputSearchDes"
                        bindValue="idStr"
                        [multiple]="false"
                        placeholder="Variation 1"
                        (open)="changeVariation($event, i, 1)"
                        (change)="checkVariationValue($event, i, 1)"
                      >
                        <ng-template ng-header-tmp>
                          <div class="has-feedback">
                            <input
                              placeholder="Search..."
                              (input)="Variation1.filter($any($event.target).value)"
                              type="text"
                              class="form-control search-input"
                              id="inputValidation"
                            />
                            <span class="form-control-feedback">
                              <i class="fa fa-search icon"></i>
                            </span>
                          </div>
                        </ng-template>
                        <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                          <div [ngOptionHighlight]="search" title="{{ item?.description }}">
                            {{ item.description }}
                          </div>
                        </ng-template>
                      </ng-select>
                    </div>
                    <div class="col-12 col-md-6 reportGenerationDrd">
                      <label
                        class="sub-header-drpdown pb-2"
                        *ngIf="sensitivityReportForm.get('items').at(i).get('variationTwo').value"
                        >Variation 2</label
                      >
                      <label
                        *ngIf="
                          sensitivityReportForm.get('items').at(i).get('variationOne').value &&
                          !sensitivityReportForm.get('items').at(i).get('variationTwo').value
                        "
                        style="visibility: hidden"
                        class="sub-header-drpdown pb-2"
                        >Holder_Text</label
                      >
                      <ng-select
                        [clearable]="true"
                        [clearOnBackspace]="false"
                        #Variation2
                        [formControlName]="'variationTwo'"
                        [items]="variationLists"
                        [searchable]="false"
                        bindLabel="description"
                        [searchFn]="commonInputSearchDes"
                        bindValue="idStr"
                        [multiple]="false"
                        placeholder="Variation 2"
                        (open)="changeVariation($event, i, 2)"
                        (change)="checkVariationValue($event, i, 2)"
                      >
                        <ng-template ng-header-tmp>
                          <div class="has-feedback">
                            <input
                              placeholder="Search..."
                              (input)="Variation2.filter($any($event.target).value)"
                              type="text"
                              class="form-control search-input"
                              id="inputValidation"
                            />
                            <span class="form-control-feedback">
                              <i class="fa fa-search icon"></i>
                            </span>
                          </div>
                        </ng-template>
                        <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                          <div [ngOptionHighlight]="search" title="{{ item?.description }}">
                            {{ item.description }}
                          </div>
                        </ng-template>
                      </ng-select>
                    </div>
                  </div>
                  <div class="row scenarios-div ng-select-div reportGenerationDrd">
                    <div class="col-12 col-md-6">
                      <label
                        class="sub-header-drpdown pb-2"
                        *ngIf="sensitivityReportForm.get('items').at(i).get('variationThree').value"
                        >Variation 3</label
                      >
                      <label
                        *ngIf="
                          !sensitivityReportForm.get('items').at(i).get('variationThree').value &&
                          sensitivityReportForm.get('items').at(i).get('variationFour').value
                        "
                        style="visibility: hidden"
                        class="sub-header-drpdown pb-2"
                        >Holder_Text</label
                      >
                      <ng-select
                        [clearable]="true"
                        [clearOnBackspace]="false"
                        #Variation3
                        [formControlName]="'variationThree'"
                        [items]="variationLists"
                        [searchable]="false"
                        bindLabel="description"
                        [searchFn]="commonInputSearchDes"
                        bindValue="idStr"
                        [multiple]="false"
                        placeholder="Variation 3"
                        (open)="changeVariation($event, i, 3)"
                        (change)="checkVariationValue($event, i, 3)"
                      >
                        <ng-template ng-header-tmp>
                          <div class="has-feedback">
                            <input
                              placeholder="Search..."
                              (input)="Variation3.filter($any($event.target).value)"
                              type="text"
                              class="form-control search-input"
                              id="inputValidation"
                            />
                            <span class="form-control-feedback">
                              <i class="fa fa-search icon"></i>
                            </span>
                          </div>
                        </ng-template>
                        <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                          <div [ngOptionHighlight]="search" title="{{ item?.description }}">
                            {{ item.description }}
                          </div>
                        </ng-template>
                      </ng-select>
                    </div>
                    <div class="col-12 col-md-6 reportGenerationDrd">
                      <label
                        class="sub-header-drpdown pb-2"
                        *ngIf="sensitivityReportForm.get('items').at(i).get('variationFour').value"
                        >Variation 4</label
                      >
                      <label
                        *ngIf="
                          sensitivityReportForm.get('items').at(i).get('variationThree').value &&
                          !sensitivityReportForm.get('items').at(i).get('variationFour').value
                        "
                        style="visibility: hidden"
                        class="sub-header-drpdown pb-2"
                        >Holder_Text</label
                      >
                      <ng-select
                        [clearable]="true"
                        [clearOnBackspace]="false"
                        #Variation4
                        [formControlName]="'variationFour'"
                        [items]="variationLists"
                        [searchable]="false"
                        bindLabel="description"
                        [searchFn]="commonInputSearchDes"
                        bindValue="idStr"
                        [multiple]="false"
                        placeholder="Variation 4"
                        (open)="changeVariation($event, i, 4)"
                        (change)="checkVariationValue($event, i, 4)"
                      >
                        <ng-template ng-header-tmp>
                          <div class="has-feedback">
                            <input
                              placeholder="Search..."
                              (input)="Variation4.filter($any($event.target).value)"
                              type="text"
                              class="form-control search-input"
                              id="inputValidation"
                            />
                            <span class="form-control-feedback">
                              <i class="fa fa-search icon"></i>
                            </span>
                          </div>
                        </ng-template>
                        <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                          <div [ngOptionHighlight]="search" title="{{ item?.description }}">
                            {{ item.description }}
                          </div>
                        </ng-template>
                      </ng-select>
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="add-btn-snt"
                [ngbTooltip]="tooltipMessage"
                placement="auto"
                tooltipClass="sku-tooltip"
                *ngIf="tooltipMessage; else noTooltip"
              >
                <button
                  [disabled]="checkDisabledRef()"
                  class="blue-hoki-add"
                  type="button"
                  id="btnmanufacturingprocessofmaterial"
                  (click)="addItem()"
                  (mouseenter)="changeImageOnHover(true)"
                  [innerHTML]="headerBtn"
                  (mouseleave)="changeImageOnHover(false)"
                ></button>
              </div>

              <ng-template #noTooltip>
                <button
                  [disabled]="checkDisabledRef()"
                  class="blue-hoki-add"
                  type="button"
                  id="btnmanufacturingprocessofmaterial"
                  (click)="addItem()"
                  (mouseenter)="changeImageOnHover(true)"
                  [innerHTML]="headerBtn"
                  (mouseleave)="changeImageOnHover(false)"
                ></button>
              </ng-template>

              <hr class="hr" />
            </div>
          </div>
        </app-feature-lock>
      </ng-container>

      <!-- Generate button -->

      <div class="setButtonAndError text-margin">
        <div class="modal-footer">
          <button
            *ngIf="isCheckeportListByFormateById == 1 && !isExportProjectSummary"
            [disabled]="
              (reportChartForm.controls['newFormateList'].invalid ||
                reportChartForm.controls['reportFormatByList'].invalid) &&
              isCheckeportListByFormateById != NewReportFormatEnum.ExportRawData &&
              isCheckeportListByFormateById != NewReportFormatEnum.ExportRawDataNew
            "
            (click)="onGenerateReport('save')"
            class="modelBtn"
          >
            Save
          </button>
          <button
            *ngIf="!isExportProjectSummary"
            [innerHTML]="buttonName"
            joyrideStep="adv-19"
            stepPosition="right"
            text="Generate the report and view your results!
            Remember you can always go back to edit or add anything you've missed."
            type="submit"
            class="ISOsaveBtn"
            (click)="onGenerateReport()"
            [disabled]="
              (reportChartForm.controls['newFormateList'].invalid ||
                reportChartForm.controls['reportFormatByList'].invalid ||
                reportChartForm.controls['includeCategories'].invalid ||
                !isReportGeneratable) &&
              isCheckeportListByFormateById != NewReportFormatEnum.ExportRawData &&
              isCheckeportListByFormateById != NewReportFormatEnum.ExportRawDataNew
            "
          ></button>
          <button
            type="button"
            *ngIf="
              reportFormatName == lcaString && !isExportProjectSummary && reportTypeIdByList != 13
            "
            (click)="openShareModal()"
            class="next-btn modelBtn"
            [disabled]="
              (reportChartForm.controls['newFormateList'].invalid ||
                reportChartForm.controls['reportFormatByList'].invalid ||
                !isReportGeneratable) &&
              isCheckeportListByFormateById != 3
            "
          >
            Share
          </button>
          <!-- Export to Excel with results — single button shown only when the
               new "Export to Excel with results" report format option is selected -->
          <button
            *ngIf="isExportProjectSummary"
            name="Export Project Summary"
            type="button"
            (click)="onExportProjectSummary()"
            [disabled]="isExporting"
            class="modelBtn"
          >
            Export
          </button>
        </div>

        <div
          class="redErrorTag"
          *ngIf="
            finalSubmit &&
            (reportChartForm.controls['includeScenario']?.invalid ||
              reportChartForm.controls['functionalUnit']?.invalid ||
              reportChartForm.controls['baselineScenario']?.invalid ||
              reportChartForm.controls['impactCategories']?.invalid ||
              reportChartForm.controls['includeCategories']?.invalid ||
              (isCheckISOReport && reportChartForm.controls['functionalUnitText']?.invalid) ||
              isCheckVariation)
          "
        >
          <div class="bigScreenErrContain">
            <div>
              <span> <img src="./assets/icons/swalDeletion.svg" width="53" height="48" /></span>
            </div>
            <div>
              <div class="mb-3">
                <span style="color: #f00">To proceed please complete the following fields : </span>
              </div>
              <div class="topBottomCss">
                <div *ngIf="reportChartForm.controls['includeScenario']?.invalid">
                  Please select scenarios
                </div>
              </div>
              <div class="topBottomCss">
                <div *ngIf="reportChartForm.controls['functionalUnit']?.invalid">
                  Function unit is required
                </div>
              </div>
              <div class="topBottomCss">
                <div *ngIf="reportChartForm.controls['baselineScenario']?.invalid">
                  Please select base scenario
                </div>
              </div>
              <div class="topBottomCss">
                <div *ngIf="reportChartForm.controls['impactCategories']?.invalid">
                  Impact categories are required
                </div>
              </div>
              <div class="topBottomCss">
                <div *ngIf="reportChartForm.controls['includeCategories']?.invalid">
                  Categories to include are required
                </div>
              </div>
              <div class="topBottomCss">
                <ng-container *ngTemplateOutlet="functionalUnitTextError"></ng-container>
              </div>
              <div class="topBottomCss" *ngIf="isCheckVariation">Variation is required</div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>
<ng-template #functionalUnitTextError>
  <div *ngIf="isCheckISOReport && reportChartForm.controls['functionalUnitText']?.invalid">
    Please enter functional unit text
  </div>
</ng-template>
